import React from 'react';
import RangeSlider from 'components/rangeSlider/RangeSlider';

function AutomatedVideoControls(props) {
  const { title, controls } = props;

  return (
    <div className="controls-section">
      <p className="title">{title}</p>
      <div className="controls">
        {controls.map(control => (
          <RangeSlider key={control.key} control={control} />
        ))}
      </div>
    </div>
  );
}

export default AutomatedVideoControls;
